export function validateMandatory(value, mandatory) {
  if (!mandatory || mandatory.required !== true) return { valid: true };
  const empty = value === null || value === undefined || (typeof value === 'string' && value.trim() === '');
  if (empty) return { valid: false, code: 'MANDATORY' };
  return { valid: true };
}
